import { fetch } from '../../utility/fetch.js';
import {
  tables as staticConfig,
  parseFromApiResponse,
} from '../../static/tables/index.js';

export default {
  state: {
    loadedFromDb: false,
    tables: [],
    promise: null,
    siteConfigValues: {},
    siteConfigFetchedFresh: false,
  },
  mutations: {
    setAsLoaded(state) {
      state.loadedFromDb = true;
    },
    setTables(state, newTables) {
      state.tables = newTables;
    },
    setPromise(state, promise) {
      state.promise = promise;
    },
    setSiteConfigValue(state, { StandardName, Value }) {
      state.siteConfigValues[StandardName] = Value;
    },
    setSiteConfigFetchedFresh(state, value) {
      state.siteConfigFetchedFresh = value;
    },
  },
  actions: {
    async LOAD_COLUMN_CONFIGS({ commit, state }) {
      if (state.promise) {
        return state.promise;
      }
      let promise = fetch('/SiteConfiguration/GetTableConfigs').then(
        (response) => {
          const dbTables = parseFromApiResponse(response, staticConfig);
          const configTables = JSON.parse(JSON.stringify(staticConfig));
          const dbTableKeys = new Set(dbTables.map((t) => t.key));
          const configWithNoDb = configTables.filter(
            (t) => !dbTableKeys.has(t.key)
          );
          const newTables = [...dbTables, ...configWithNoDb].sort((t1, t2) => {
            const val1 = t1.name || t1.key;
            const val2 = t2.name || t2.key;
            if (val1 < val2) return -1;
            if (val1 > val2) return 1;
            return 0;
          });
          commit('setTables', newTables);
          commit('setAsLoaded');
        }
      );
      commit('setPromise', promise);
      return state.promise;
    },
    // eslint-disable-next-line complexity
    async LOAD_SITE_CONFIG_VALUES({ commit }) {
      let configResponse = [];
      const cachedResponse = sessionStorage.getItem('siteConfigValues');

      const channel = new BroadcastChannel('siteConfigValueChanged');
      channel.addEventListener('message', (event) => {
        sessionStorage.setItem('isSiteConfigValuesChanged', event.data);
      });

      const isConfigChanged =
        sessionStorage.getItem('isSiteConfigValuesChanged') || 0;
      if (cachedResponse) {
        const lastCacheTime = sessionStorage.getItem(
          'siteConfigValuesCacheTime'
        );
        const currentTime = new Date().getTime();
        // 30 minute cache duration
        if (!lastCacheTime || currentTime - lastCacheTime < 1000 * 60 * 30) {
          configResponse = JSON.parse(cachedResponse);
        }
      }
      if (configResponse.length == 0 || isConfigChanged == 1) {
        configResponse = await fetch(
          '/SiteConfigurationApi/GetAllColKeyValues?returnAll=true'
        );
        // update cache entries
        sessionStorage.setItem(
          'siteConfigValues',
          JSON.stringify(configResponse)
        );
        sessionStorage.setItem(
          'siteConfigValuesCacheTime',
          new Date().getTime()
        );
        sessionStorage.setItem('isSiteConfigValuesChanged', 0);
        commit('setSiteConfigFetchedFresh', true);
      }
      // update store values
      for (let i = 0; i < configResponse.length; i++) {
        const { StandardName, Value } = configResponse[i];
        commit('setSiteConfigValue', { StandardName, Value });
      }
    },
    async LOAD_IDLE_CONFIG_VALUES({ commit }) {
      const [idleTimeout, idleAlertTime] = await Promise.all([
        fetch('/SiteConfiguration/GetColKey?key=IdleTimeOut'),
        fetch('/SiteConfiguration/GetColKey?key=IdleAlertTime'),
      ]);
      commit('setSiteConfigValue', { StandardName: 'IdleTimeOut', Value: idleTimeout[0].Value });
      commit('setSiteConfigValue', { StandardName: 'IdleAlertTime', Value: idleAlertTime[0].Value });
    },
  },
  getters: {
    tableConfigsLoaded: (state) => state.loadedFromDb,
    tableConfigs: (state) => state.tables,
    simpleTableMaxLimit: (state) =>
      state.siteConfigValues['SimpleTableMaxSize'],
    actionableTableMaxLimit: (state) =>
      state.siteConfigValues['ActionableTableMaxSize'],
    granularTableMaxLimit: (state) =>
      state.siteConfigValues['GranularTableMaxSize'],
    idleTimeout: (state) => state.siteConfigValues['IdleTimeOut'],
    idleAlertTime: (state) => state.siteConfigValues['IdleAlertTime'],
  },
};
